import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <div className="pt-16 md:pt-20">
      {/* Page Header */}
      <section className="bg-gradient-to-r from-[#033644] to-[#1E3A8A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
            Contáctanos
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Estamos aquí para ayudarte. Envíanos un mensaje y nos pondremos en
            contacto contigo lo antes posible
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16 md:py-24 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            {/* Contact Form */}
            <div>
              <ContactForm />
            </div>

            {/* Contact Information & Map */}
            <div className="space-y-8">
              {/* Contact Details */}
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <h3 className="text-2xl font-heading font-semibold text-[#033644] mb-6">
                  Información de Contacto
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-4">
                    <i className="fas fa-map-marker-alt text-2xl text-[#FFA500] mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">
                        Dirección
                      </h4>
                      <p className="text-gray-600">Malabo, Guinea Ecuatorial</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <i className="fas fa-envelope text-2xl text-[#FFA500] mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
                      <a
                        href="mailto:info@technova-eg.com"
                        className="text-[#033644] hover:text-[#FFA500] transition-colors"
                        data-testid="link-contact-email"
                      >
                        info@technova-eg.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <i className="fas fa-phone text-2xl text-[#FFA500] mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">
                        Teléfono
                      </h4>
                      {/*
                      <a
                        href="tel:+240XXXXXXXXX"
                        className="text-[#033644] hover:text-[#FFA500] transition-colors"
                        data-testid="link-contact-phone"
                      >
                        +240-XXX-XXX-XXX
                      </a>
                       */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Google Maps Embed */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden h-80">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127402.40819149886!2d8.782996!3d3.750412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1062178c0c8c4f19%3A0x4b3dbf5c9b1e1e1e!2sMalabo%2C%20Equatorial%20Guinea!5e0!3m2!1sen!2s!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación de Technova en Malabo"
                  data-testid="map-location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}